import { jsx } from 'panel';
export function template() {
  return jsx("div", {
    sel: '.calendar'
  });
}